import styled from "styled-components";
import { inputBox } from "common/Inputs/styles";
import { CSSProperties, PropsWithChildren } from "react";

interface InputBoxProps {
  onClick?: () => void;
  style?: CSSProperties;
  className?: string;
}

const InputBox = ({
  onClick,
  style,
  children,
  className,
}: PropsWithChildren<InputBoxProps>) => {
  return (
    <Wrapper onClick={onClick} style={style} className={className}>
      {children}
    </Wrapper>
  );
};

export default InputBox;

const Wrapper = styled.div<{ $bgColor?: string; onClick?: () => void }>`
  ${inputBox};
  height: 32px;
  padding: 0 11px;
  display: flex;
  align-items: center;
  ${(p) =>
    !!p.onClick &&
    `
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    cursor: pointer;
    &:hover {
      border: 1px solid ${(p) => p.theme.colors.primaryBlue};
    }
  `};
`;
